import {WebClient} from "../../store/clients/client";
import {FeatureRequest} from "../../models/support";

// ---------------------------------------- ADMIN ----------------------------------------
export async function adminFetchFeatureRequestsPaginated(page:number) {
    try {
        const response = await WebClient.AdminGetListFeatureRequests(page);

        if (response.status === 200) {
            return response.data['results'] as FeatureRequest[]
        }
    }catch (e) {}

    return [] as FeatureRequest[];
}

export async function adminFetchFeatureRequest(ticket:FeatureRequest) : Promise<FeatureRequest> {
    try {
        const response = await WebClient.AdminGetFeatureRequest(ticket);

        if (response.status === 200) {
            return response.data as FeatureRequest
        }
    }catch (e) {}

    return {} as FeatureRequest;
}

export async function adminUpdateFeatureRequest(ticket:FeatureRequest) : Promise<FeatureRequest> {
    try {
        const response = await WebClient.AdminUpdateFeatureRequest(ticket);

        if (response.status === 200) {
            return response.data as FeatureRequest
        }
    }catch (e) {}

    return {} as FeatureRequest;
}

export async function adminDeleteFeatureRequest(ticket:FeatureRequest) : Promise<boolean> {
    try {
        const response = await WebClient.AdminDeleteFeatureRequest(ticket);

        if (response.status === 204) {
            return true
        }
    }catch (e) {}

    return false;
}


// ---------------------------------------- USER ----------------------------------------
export async function newFeatureRequest(ticket:FeatureRequest|any) : Promise<FeatureRequest> {
    try {
        const response = await WebClient.NewFeatureRequest(ticket);

        if (response.status === 200) {
            return response.data as FeatureRequest
        }
    }catch (e) {}

    return {} as FeatureRequest;
}

export async function fetchFeatureRequestsPaginated(page:number) {
    try {
        const response = await WebClient.GetListFeatureRequests(page);

        if (response.status === 200) {
            return response.data['results'] as FeatureRequest[]
        }
    }catch (e) {}

    return [] as FeatureRequest[];
}

export async function fetchFeatureRequest(ticket:FeatureRequest) : Promise<FeatureRequest> {
    try {
        const response = await WebClient.GetFeatureRequest(ticket);

        if (response.status === 200) {
            return response.data as FeatureRequest
        }
    }catch (e) {}

    return {} as FeatureRequest;
}

export async function deleteFeatureRequest(ticket:FeatureRequest) : Promise<boolean> {
    try {
        const response = await WebClient.DeleteFeatureRequest(ticket);

        if (response.status === 204) {
            return true
        }
    }catch (e) {}

    return false;
}
